export default {
    methods: {
        formatCpfCnpj(valor) {
          if(valor == null || valor == ''){
            return '';
          }
            const limpo = valor.replace(/\D/g, ''); // Remove caracteres não numéricos

            if (limpo.length === 11) {
              // Formata como CPF
              return limpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else if (limpo.length === 14) {
              // Formata como CNPJ
              return limpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
            } else {
              // Retorna o valor sem formatação se não for CPF nem CNPJ
              return valor;
            }

        }
    },
};
